<template>
    <div class="mx-auto px-4 py-4 sm:px-6 lg:px-6 min-h-80vh">
        <h1 class="text-lg leading-6 font-medium">
            Company Statistics Report
        </h1>
        <div class="
          bg-white
          shadow
          overflow-hidden
          sm:rounded-lg
          shadow
          overflow-auto
          border-b border-gray-200
          sm:rounded-lg
        ">
            <form class="mt-5 sm:flex sm:items-center px-8">
                <div class="w-full sm:max-w-md mr-2">
                    <label for="month_select" class="sr-only">Select Month</label>
                    <select id="month_select" class="
                        h-10
                        form-select
                        appearance-none
                        block
                        w-full
                        px-3
                        py-1.5
                        text-base
                        font-normal
                        text-gray-700
                        bg-white bg-clip-padding bg-no-repeat
                        border border-solid border-gray-300
                        rounded
                        transition
                        ease-in-out
                        m-0
                        focus:text-gray-700
                        focus:bg-white
                        focus-border-navy
                    " aria-label="Select Month" v-model="search.month">
                    <option value="">Select Month</option>
                    <option v-for="(month, index) in months" :key="index" :value="month.value">{{ month.label }}</option>
                    </select>
                </div>
                <div class="w-full sm:max-w-md mr-2">
                    <label for="year_select" class="sr-only">Select Year</label>
                    <select id="year_select" class="
                        h-10
                        form-select
                        appearance-none
                        block
                        w-full
                        px-3
                        py-1.5
                        text-base
                        font-normal
                        text-gray-700
                        bg-white bg-clip-padding bg-no-repeat
                        border border-solid border-gray-300
                        rounded
                        transition
                        ease-in-out
                        m-0
                        focus:text-gray-700
                        focus:bg-white
                        focus-border-navy
                    " aria-label="Select Year" v-model="search.year">
                    <option value="">Select Year</option>
                    </select>
                </div>
                
                <div class="w-full sm:max-w-md mr-2 items-center justify-between">
                    <button class="
                  mt-1
                  mr-2
                  relative
                  inline-flex
                  items-center
                  px-4
                  py-2
                  border border-transparent
                  shadow-sm
                  text-sm
                  font-medium
                  rounded-md
                  text-white
                  focus:outline-none focus:ring-2 focus:ring-offset-2
                  cobalt-button-color
                " type="button" @click="getReportData()">
                        Search
                    </button>
                    <button class="
                  mt-1
                  mr-2
                  relative
                  inline-flex
                  items-center
                  px-4
                  py-2
                  border border-transparent
                  shadow-sm
                  text-sm
                  font-medium
                  rounded-md
                  text-white
                  focus:outline-none focus:ring-2 focus:ring-offset-2
                  cobalt-button-color
                " v-if="data?.length > 0" type="button" @click="exportCSV($event)">
                        Export
                    </button>
                    <button class="
                  mt-2
                  inline-flex
                  items-center
                  px-4
                  py-2
                  border border-transparent
                  rounded-md
                  shadow-sm
                  text-sm
                  font-medium
                  text-white
                  bg-gray-600
                  hover:bg-gray-800
                  focus:outline-none
                  focus:ring-2
                  focus:ring-offset-2
                  focus:ring-gray-500
                " type="button" @click="clearFilter()">
                        Clear
                    </button>
                </div>
            </form>
            <div
              ref="resultsRegion"
              tabindex="0"
              role="region"
              aria-label="Company statistics report results"
              aria-describedby="company_statistics_columns"
            >
              <span id="company_statistics_columns" class="sr-only">
                Company statistics report results table. Columns:
                {{ columns.map(c => c.title).join(', ') }}.
              </span>
              <DataTable 
              ref="dt"
              :resizableColumns="true" columnResizeMode="expand"
                class="mt-5 min-w-full divide-y divide-gray-200 font-xs company_statistics"
                :value="data"
                @page="onPageChange($event)"
              :totalRecords="totalRecords"
              :first="first"
              :lazy="lazyParams" :paginator="true"
                :alwaysShowPaginator="false"
                :rowsPerPageOptions=[5,10,20,50,70,100]
                :rows="10"
              >
                <template #empty>
                  No Records Found
                </template>
                <Column
                    v-for="column in columns"
                    :key="column.title"
                    :field="column.key"
                    :style="{ 'width': '50px' }"
                    exportFilename="exportfilename"
                >
                    <template #header>
                        {{ column.title }}
                    </template>
                    <template #body="slotProps">
                        <span>
                          <span class="sr-only">{{ getCellAriaLabel(column, slotProps?.data) }}</span>
                          <span aria-hidden="true">
                            <template v-if="column.key == 'acc_penetration'">
                              {{ slotProps?.data?.acc_penetration }}%
                            </template>
                            <template v-else>
                              {{ slotProps.data[column.key] }}
                            </template>
                          </span>
                        </span>
                    </template>
                </Column>
              </DataTable>
            </div>
        </div>
    </div>
</template>
  
<script>
import { mapState } from "vuex"; // importing mapState for get access state level variables.
import $ from "jquery"; // To use jquery
import Constants from "../constants.ts";
// import axios from "axios";
import { ref } from 'vue';

export default {
    data() {
        return {
            focusedInput: null,
            API_BASE: Constants.API_BASE,
            columns: [
                {
                    title: "Company #",
                    key: "com_num",
                },
                {
                    title: "Company Name",
                    key: "name",
                },
                {
                    title: "Company Status",
                    key: "com_status",
                },
                {
                    title: "# of Eligibile Employees",
                    key: "eligible_emp_count",
                },
                {
                    title: "# of Active Policy Holders",
                    key: "active",
                },
                {
                    title: "Account Penetration",
                    key: "acc_penetration",
                },
                {
                    title: "# of Inactive Policy Holders",
                    key: "inactive",
                },
                {
                    title: "# of Terminated Policy Holders",
                    key: "terminate",
                }
            ],
            search: {
                month: '',
                year: '',
                flt_str: "",
            },
            months: [
                { value: '01', label: 'January' },
                { value: '02', label: 'February' },
                { value: '03', label: 'March' },
                { value: '04', label: 'April' },
                { value: '05', label: 'May' },
                { value: '06', label: 'June' },
                { value: '07', label: 'July' },
                { value: '08', label: 'August' },
                { value: '09', label: 'September' },
                { value: '10', label: 'October' },
                { value: '11', label: 'November' },
                { value: '12', label: 'December' },
            ],
            first : ref(0),
            totalRecords :ref(0),
            lazyParams : ref({}),
            data: ref(0),
            originalData: [],
            totalAmount: 0,
            totalComm: 0,
            config: {
                wrap: true,
                altFormat: "m-d-Y",
                altInput: true,
                dateFormat: "m-d-Y",
            },
        };
    },
    computed: mapState(["agent_user","token"]), // get central level variable from store
    mounted() {
        var currentYear = new Date().getFullYear();
            var selectElement = document.getElementById('year_select');
                                            
            for (var i = 0; i < 5; i++) {
                var year = currentYear - i;
                var option = document.createElement('option');
                option.value = year;
                option.textContent = year;
                selectElement.appendChild(option);
            }
            const currentDate = new Date();
            const previousMonth = currentDate.getMonth() === 0 ? 12 : currentDate.getMonth();
            const previousYear = currentDate.getMonth() === 0 ? currentDate.getFullYear() - 1 : currentDate.getFullYear();
            this.search.month = String(previousMonth).padStart(2, '0');
            this.search.year = String(previousYear);
            // this.getReportData();
            this.lazyParams.value = {
                first: 0,
                rows: 10,
            };
            this.fixDataTableAria();
    },
    updated() {
        this.fixDataTableAria();
    },
    methods: {
        fixDataTableAria() {
            this.$nextTick(() => {
                const root = this.$refs.dt?.$el;
                if (!root) return;
                root.querySelectorAll('th[role="cell"]').forEach((th) => {
                    th.setAttribute('role', 'columnheader');
                });
                const paginatorLabels = {
                    '.p-paginator-first': 'First Page',
                    '.p-paginator-prev': 'Previous Page',
                    '.p-paginator-next': 'Next Page',
                    '.p-paginator-last': 'Last Page',
                };
                Object.entries(paginatorLabels).forEach(([selector, label]) => {
                    root.querySelectorAll(selector).forEach((btn) => {
                        btn.setAttribute('aria-label', label);
                        btn.querySelector('.p-paginator-icon')?.setAttribute('aria-hidden', 'true');
                    });
                });
                root.querySelectorAll('.p-paginator .p-hidden-accessible input[readonly]').forEach((input) => {
                    input.removeAttribute('aria-expanded');
                    if (!input.getAttribute('aria-label') && !input.getAttribute('aria-labelledby')) {
                        input.setAttribute('aria-label', 'Rows per page');
                    }
                });
                root.querySelectorAll('.p-paginator .p-dropdown-trigger').forEach((trigger) => {
                    trigger.setAttribute('aria-label', 'Rows per page');
                    trigger.querySelector('.p-dropdown-trigger-icon')?.setAttribute('aria-hidden', 'true');
                });
            });
        },
        getCellAriaLabel(column, rowData) {
            const raw = rowData ? rowData[column.key] : "";
            const value = raw === null || raw === undefined || raw === "" ? "blank" : String(raw);
            return `${column.title}: ${value}`;
        },
        onSort(event){
            console.log(event)
            this.lazyParams.value = event;
            this.getReportData(event);
    },
        onPageChange(event) {
        this.lazyParams.value = event;
        this.getReportData(event);
        $('html, body').animate({ scrollTop: 0 });
    },
        onFocus(refKey) {
            this.focusedInput = refKey;
        },
        exportCSV() {
            if(this.search.month=='' || this.search.month==null || this.search.year=='' || this.search.year==null){
                this.$toast.error("Please select month/year.");
                return false;
            }
            // this.$refs.dt.exportCSV();
            let filter_str = "?";
          
            if(this.search.month=='' || this.search.month==null || this.search.year=='' || this.search.year==null){
                this.$toast.error("Please select month/year.");
                return false;
            }
            filter_str += "&month=" + this.search.month;
            filter_str += "&year=" + this.search.year;
            filter_str += "&report_name=company_statistics_report";
            filter_str += "&act=" + encodeURIComponent(this.token);
            filter_str+="&agents="+this.agent_user.id;
            console.log(filter_str)
            window.location.href = this.API_BASE + "export_to_csv.php" + filter_str;
        },
        clearFilter() {
            this.search.flt_str="";
            this.search.year="";
            this.search.month="";
            this.data=[];
            // this.getReportData();
        },
        getReportData(event) {

            this.lazyParams.value = { ...this.lazyParams.value, first: event?.first || this.first };
            if(this.search.month=='' || this.search.month==null || this.search.year=='' || this.search.year==null){
                this.$toast.error("Please select month/year.");
                return false;
            }
            document.getElementById("loader").classList.remove("hidden");

            this.search.flt_str = "and (YEAR(a.job_run_at) = '"+this.search.year+"' AND MONTH(a.job_run_at) = '"+this.search.month+"')";
    
                let filter={'limit':10,'offset':0,'sortField':'name asc'};
                console.log(event)
                if(event?.rows>0){
                        let order='asc';
                        if(event.sortOrder==-1){
                            order='desc';
                        }
                        if(event.sortField!='' && event.sortField!=null){
                            if(event.sortField=='active'){
                                event.sortField='active_member';
                            }else if(event.sortField=='inactive'){
                                event.sortField='inactive_member';
                            }else if(event.sortField=='terminate'){
                                event.sortField='terminate_member';
                            }else if(event.sortField=='acc_penetration'){
                                event.sortField='name';
                            }
                        }else{
                            event.sortField='name'; 
                        }
                        filter={'limit':event.rows,'offset':event.first,'sortField':event.sortField+' '+order};
                    }
                    
                this.$http
                    .post(
                        `company_statistics_report.php`,
                        {'search':this.search,"paginate":filter},
                        {
                            headers: {
                                Authorization: this.token,
                                AgentSelected:this.agent_user.id
                            },
                        }
                    )
                    .then((response) => {
                        document.getElementById("loader").classList.add("hidden");
                        this.$store.state.loader = false;
                        if (response?.data?.status == "unAuthorized") {
                                document.getElementById("loader").classList.add("hidden");
                                this.$toast.error(response.data.message);
                                this.$store.dispatch("logout");
                                this.$router.push("/login");
                            } else {
                            this.data = response.data.data;
                            this.totalRecords = response.data.totalRecords;
                            this.$nextTick(() => {
                              this.$refs?.resultsRegion?.focus?.();
                            });
                        }
                    })
                    .catch((e) => {
                        this.$store.state.loader = false;
                        console.log("e", e);
                        document.getElementById("loader").classList.add("hidden");
                    })
        }
    },
};
</script>
<!-- <style scoped>
.p-datatable-resizable .p-datatable-thead > tr > th, .p-datatable-resizable .p-datatable-tfoot > tr > td, .p-datatable-resizable .p-datatable-tbody > tr > td{
  white-space: normal !important;
  font-size: 14px;
}
</style>x -->